var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.998,
    height: 32.998,
    viewBox: "0 0 32.998 32.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#f36f3a;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.951,142.473a.3.3,0,0,1-.028-.062.323.323,0,0,1-.013-.065.314.314,0,0,1-.007-.034V126.983A15.335,15.335,0,1,0,198.9,154.96L189.965,142.5A.272.272,0,0,1,189.951,142.473Z",
    transform: "translate(-174.235 -126.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,16A16,16,0,1,1,25.372,28.955a.212.212,0,0,1-.047.048c-.013.01-.028.007-.042.015A15.988,15.988,0,0,1,0,16Zm.662,0a15.328,15.328,0,0,0,24,12.649l-8.93-12.456a.249.249,0,0,1-.014-.032.337.337,0,0,1-.028-.061.433.433,0,0,1-.014-.065A.238.238,0,0,1,15.669,16V.67A15.352,15.352,0,0,0,.662,16Zm15.669-.105L25.2,28.263A15.324,15.324,0,0,0,31.337,16,15.324,15.324,0,0,1,25.2,28.263ZM31.337,16A15.351,15.351,0,0,0,16.331.67,15.354,15.354,0,0,1,31.337,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteSent);
export default __webpack_public_path__ + "static/media/quote-sent.3d6568de0dac5d66455f6f6104b17861.svg";
export { ForwardRef as ReactComponent };